import OpUI from "@oppein/oppein-component";
import "@oppein/oppein-component/dist/oppein-component.css";
import { getEnvMode } from "./getEnvMode";
import { AppCode, SubAppCode } from "@/api/factory";
import Vue from "vue";
Vue.use(OpUI, {
  env: getEnvMode(),
  appCode: AppCode,
  subAppCode: SubAppCode,
});



// WEBPACK FOOTER //
// ./src/util/useOpUI.js